export default [
    {
        path: '/app/index.html',
        component: (resolve) => require(['@/view/app/index.vue'],resolve),
    }
]
